import { supportUrl } from "@/lib/env";

export function getSupportEmail(): string {
  if (supportUrl.startsWith("mailto:")) {
    return supportUrl.replace(/^mailto:/i, "").split("?")[0] ?? supportUrl;
  }
  return supportUrl;
}

export function getSupportMailtoHref(): string {
  if (supportUrl.startsWith("mailto:")) {
    return supportUrl;
  }
  return `mailto:${supportUrl}`;
}
